import { useQuery } from "@tanstack/react-query";
import { errorMessage, useTRPC } from "../../lib/api";
import { ErrorText, Section } from "../../ui";

/**
 * A shared workspace's own page (WP-028): people invited to it who have not signed in yet. They
 * join it on their first sign-in; nothing shows once everyone invited has.
 */
export function WorkspaceInvitations({ workspaceId }: { workspaceId: string }) {
  const trpc = useTRPC();
  const invitations = useQuery(trpc.workspaces.invitations.queryOptions({ workspaceId }));
  if (invitations.isError) return <ErrorText>{errorMessage(invitations.error)}</ErrorText>;
  if (invitations.data === undefined || invitations.data.length === 0) return null;
  return (
    <Section title="Invited, not signed in yet" description="They join this workspace when they first sign in.">
      <ul className="flex flex-col gap-1 text-sm">
        {invitations.data.map((i) => (
          <li key={i.email}>
            <span className="font-medium text-text">{i.name}</span> <span className="text-muted">{i.email}</span>
          </li>
        ))}
      </ul>
    </Section>
  );
}
